import React from 'react';
import { ArcStack } from '@src/core/ui';
import { Sidebars } from './sidebars';
import Maps from './maps';
import { useDispatch } from 'react-redux';
import { setSelectedDrone } from '@src/features/drone/redux/actions';

export const DronesPage: React.FC = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => {
      // Cleanup: reset selected drone when component unmounts
      dispatch(setSelectedDrone(null));
    };
  }, [dispatch]);

  return (
    <ArcStack direction='row'>
      <Sidebars />
      <Maps />
    </ArcStack>
  );
};